// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__5uI24","labelrow":"LoginForm_labelrow__t3ubx","p":"LoginForm_p__Fv4AQ","warning":"LoginForm_warning__N4WK0","button":"LoginForm_button__jf+Ww"};